<template>
    <div>
        <navigation-bar Close/>

        <div class="main container">
            <h2>刪除帳號後您的帳號將發生如下變化：</h2>
            <ol class="type1">
                <li>永久註銷，無法登錄</li>
                <li>為了保障您的用戶權利，註銷後我們會永久刪除您的數據</li>
                <li>此帳號關聯的信息將無法找回</li>
                <li>為了保障您的數據安全，我們將永久刪除本帳號所屬的產品數據，無法恢復（含入會店家、訂單數據、訂單紀錄、信用卡綁定資訊與此帳號關聯的會員、優惠券、會員卡等）</li>
            </ol>

            <div class="footer-button">
                <el-button @click="$router.back()" class="cancel" round>取消</el-button>
                <el-button type="primary" @click="deleteAccount" round>確定</el-button>
            </div>

        </div>
        <loading
            :active.sync=isLoading
            :can-cancel="false"
            :is-full-page="true">
        </loading>
    </div>
</template>

<script>
    import * as constDefine from "@/store/constDefine";

    export default {
        name: "DeleteAccount",
        data() {
            return {
                isLoading: false,
                dataToken: this.$route.params.dataToken !== undefined ? this.$route.params.dataToken : "",
                dataObject: {},
            }
        },
        mounted() {
            try {
                let dataObject = this.$crypto.uriComponentToObject(this.dataToken)
                if (dataObject.usedType === this.$route.name) {
                    this.dataObject = dataObject
                } else {
                    this.$router.go(-1)
                }
            } catch (e) {
                this.$router.go(-1)
            }
        },
        methods: {
            deleteAccount() {
                this.isLoading = true;

                this.$http.fetchWithAuthEncrypt`DeleteAccount${{
                    'password': this.dataObject.password || '',
                }} ${json => {
                    this.isLoading = false;
                    if (json.status) {
                        //清除token
                        this.$auth.clearToken();
                        //清除 fcm device token
                        window.localStorage.setItem(constDefine.KEY_FCM_TOKEN, '');
                        this.$router.replace({name: 'More', params: {from: 'account', message: '已刪除帳號'}})
                    } else {
                        this.$public.showNotify(json.message, json.status);
                    }
                }}`;
            },
        },
    }
</script>
<style scoped lang="less">
    h2{
        font-size: 18px;
        margin: 30px 0 20px;
    }
    .type1{
        padding-left: 20px;
        margin-bottom: 40px;
        li{
            list-style: decimal;
            margin-bottom: 10px !important;
            font-size: 14px;
            line-height: 1.6em;
            &::marker{
                color: inherit;
            }
        }
    }
</style>
